<template>
  <div class="">
    <div class="input-group">
      <label for="supplier-name">
        {{ title }}
      </label>
      <input
        v-model="form.name"
        type="text"
        id="supplier-name"
      />
      <p
        v-if="getErrors('name', form)"
        class="input-error"
      >
        {{ getErrors('name', form) }}
      </p>
    </div>

    <div class="pt-4 flex justify-end">
      <button
        @click="save()"
        class="btn btn-primary"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3'
import checksErrors from '@/Mixins/checksErrors'

export default {
  mixins: [checksErrors],

  props: {
    title: {
      type: String,
      required: true
    },
    /**
     * Either 'product_category' or 'product_tag'
     */
    type: {
      type: String,
      required: true
    },
    postUrl: {
      type: String,
      required: true,
      default() {
        return null
      }
    }
  },

  data() {
    return {
      form: {
        name: '',
        type: this.type
      }
    }
  },

  created() {
    this.form = useForm(this.form)
  },

  methods: {
    save() {
      this.form.post(this.postUrl, {
        onFinish: () => {
          this.$emit('created')
        }
      })
    }
  }
}
</script>
